import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import {baseRoute, deviceBaseRoute, deviceUsersRoute, deviceUserRoute} from 'routes';
import { CurrentLang, MagstimFetch } from 'common';
import {REST_ENDPOINT_SETTINGS} from 'common/ApiEndpoints';

import {withRouter} from 'react-router-dom';
import routeManager from './RouteManager';
import styled from 'styled-components';

import  styledMagstimAppWrapper from 'common/controls/StyledMagstimAppWrapper'

import firebase from 'firebase/app';
import 'firebase/analytics';
import auth0Client from 'commonWeb/Auth/Auth';

import './App.scss';

const Users = React.lazy(() => import('common/views/Admin/Users/Users'));
const User = React.lazy(() => import('common/views/Admin/User/User'));

const loading = () => <div className="animated fadeIn pt-3 text-center">Loading...</div>;

const DefaultLayout = React.lazy(() => import('./commonWeb/Containers/DefaultLayout/DefaultLayout'));
const Callback = React.lazy(() => import('./commonWeb/Callback/Callback'));

class App extends Component {

  state = {
    settings: undefined, 
    mainBackground:'black'
  };

  constructor(props) {
    super(props);

    var firebaseConfig = {
      apiKey: "AIzaSyBkHKrxPgWB7WlfipXDbags8lHY_W3XC8g",
      authDomain: "magstim-pdm.firebaseapp.com",
      databaseURL: "https://magstim-pdm.firebaseio.com",
      projectId: "magstim-pdm",
      storageBucket: "magstim-pdm.appspot.com",
      messagingSenderId: "452819548435",
      appId: "1:452819548435:web:c22f3409046645fff402e6",
      measurementId: "G-E876HRXNKK"
    };

    if (process.env.NODE_ENV !== "production") {
      firebaseConfig = {
        apiKey: "AIzaSyBkHKrxPgWB7WlfipXDbags8lHY_W3XC8g",
        authDomain: "magstim-pdm.firebaseapp.com",
        databaseURL: "https://magstim-pdm.firebaseio.com",
        projectId: "magstim-pdm",
        storageBucket: "magstim-pdm.appspot.com",
        messagingSenderId: "452819548435",
        appId: "1:452819548435:web:ed6b3e8c5f7fea63f402e6",
        measurementId: "G-Y93SG3XZBW"
        };
    }
     
    firebase.initializeApp(firebaseConfig);
    firebase.analytics();

    this.props.history.listen((location, action) => {
      this.setConfigurationForLocation(location);
    });
  }

  componentDidMount() {
    
    MagstimFetch.getNoAuth(REST_ENDPOINT_SETTINGS)
    .then((data) => {
        auth0Client.setSettings(data);
        this.setState({settings: data});
    })
    .catch((error) => {
        console.log(error);    
        alert(error);  
    });

    // Tell the route manager the route the user entered
    routeManager.setUserEnteredBaseRoute(this.props.location);
    this.setConfigurationForLocation(this.props.location);
  }

  setConfigurationForLocation = (location) =>{

    // Set based on the location - as we serve the device and the PDM
    if(location !== undefined && location.pathname !== undefined){
      if(location.pathname.includes(deviceBaseRoute)){
        localStorage.setItem('Configuration', 'Desktop')
        this.setState({mainBackground:'transparent'});
      }else{
        localStorage.setItem('Configuration', 'Web')
        this.setState({mainBackground:'black'});
      }
    }
  }

  render() {
    if (undefined === this.state.settings) {
      return (
        <Wrapper mainBackground={this.state.mainBackground} />
      );
    }
    else {
      return (
        <Wrapper mainBackground={this.state.mainBackground}>
            <React.Suspense fallback={loading()}>
              <Switch>
                <Route exact path="/" name="Callback" render={props => <Callback {...props}/>} />  
                <Route path={baseRoute} name="PDM" render={props => <DefaultLayout {...props}/>} />
                <Route exact path={deviceUsersRoute} name={CurrentLang().users} render={props => <Users {...props}/>} />  
                <Route exact path={deviceUserRoute} name={CurrentLang().user} render={props => <User {...props}/>} />  
                <Route name="Callback" render={props => <Callback {...props} />} />
              </Switch>
            </React.Suspense>
          </Wrapper>
      );
    }
  }
}

const Wrapper = styled(styledMagstimAppWrapper)`


`;

export default withRouter(App);
